var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pertentage-bar"
  }, [_c('div', {
    staticClass: "d-flex overflow-hidden"
  }, [_c('div', {
    staticClass: "font-weight-bold flex-fill text-truncate"
  }, [_vm._v(_vm._s(_vm.label))]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.displayValue) + "%")])]), _c('div', {
    staticClass: "progress mt-1"
  }, [_c('div', {
    ref: "bar",
    staticClass: "progress-bar",
    class: `bg-${_vm.color}`,
    style: `width: ${_vm.easedVal}%`,
    attrs: {
      "role": "progressbar",
      "aria-valuenow": _vm.easedVal,
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };